import { model } from "@tensorflow/tfjs";
import { max, sum } from "mathjs";
import Column from "../../MachineLearning/Column";
import Dataset, { dataSplit } from "../../MachineLearning/Dataset";
import { stateTypeF } from "../../state";

export function calcVariableImportance(
  savedModels: any[],
  trainData: dataSplit,
  allColumns: Column[]
) {
  let xTest = trainData.xTest;
  let yTest = trainData.yTest;

  let indexes = new Array(xTest.length).fill(0).map((val, index) => index);
  indexes = Dataset.shuffle(indexes);

  let shuffleLosses = Array(allColumns.length).fill(-Infinity);
  let nonShuffleLosses =
    sum(savedModels.map((model) => model.lowestLoss)) / savedModels.length;

  for (let i = 0; i < allColumns.length; i++) {
    const colName = allColumns[i].columnName;
    let xColIndexes = trainData.info.xColIndexes.get(colName);
    if (xColIndexes === undefined) {
      continue;
    }
    let arCopy: number[][] = [];
    for (let j of xColIndexes) {
      arCopy.push([...xTest.map((row) => row[j])]);
      let arShuffle = [...xTest.map((row) => row[j])];
      arShuffle = shuffleArray(arShuffle, indexes);
      xTest = replaceColumn(xTest, arShuffle, j);
    }

    let shuffleLoss = 0;
    for (let model of savedModels) {
      shuffleLoss += model.lossFunction(xTest, yTest);
    }
    shuffleLosses[i] = shuffleLoss / savedModels.length;

    // Set columns back
    let index = 0;
    for (let j of xColIndexes) {
      xTest = replaceColumn(xTest, arCopy[index], j);
      index += 1;
    }
    let a = 1;
  }
  let percentageIncrease: number[] = [];
  for (let i = 0; i < shuffleLosses.length; i++) {
    if (shuffleLosses[i] > 0) {
      let tmp =
        Math.round(
          Math.max(
            1 - nonShuffleLosses / Math.max(shuffleLosses[i], 0.0001),
            0
          ) * 100
        ) / 100;
      percentageIncrease.push(tmp);
    } else {
      percentageIncrease.push(0);
    }
  }

  const importantCols = allColumns.filter(
    (col, i) => percentageIncrease[i] > 0
  );
  const importantVars = importantCols.map((col) => col.columnName);

  let out = {};

  for (let i = 0; i < allColumns.length; i++) {
    const val = allColumns[i].columnName;
    if (importantVars.includes(val)) {
      out[val] = 100 * percentageIncrease[i];
    }
  }

  return { out, importantVars };
}

function shuffleArray(ar: number[], indexes: number[]) {
  let arCopy = [...ar];
  for (let i = 0; i < ar.length; i++) {
    ar[i] = arCopy[indexes[i]];
  }
  return ar;
}

export function replaceColumn(
  data: number[][],
  toReplace: number[],
  col: number
) {
  for (let i = 0; i < data.length; i++) {
    data[i][col] = toReplace[i];
  }
  return data;
}
